import { render, staticRenderFns } from "./main-target-template.vue?vue&type=template&id=2dbd6a96&"
import script from "./main-target-template.vue?vue&type=script&lang=js&"
export * from "./main-target-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports